function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22,14.23A1,1,0,0,0,21.3,14H16V8.7a1,1,0,0,0-.32-.76,1,1,0,0,0-.67-.28,1.17,1.17,0,0,0-.8.32A1,1,0,0,0,14,8.7V14H8.7a1.05,1.05,0,0,0-.75.32.93.93,0,0,0-.28.72,1,1,0,0,0,.3.74,1,1,0,0,0,.73.3H14V21.3a1,1,0,0,0,1,1,1.09,1.09,0,0,0,.76-.32A.92.92,0,0,0,16,21.3V16H21.3a1.05,1.05,0,0,0,.75-.32,1,1,0,0,0,.28-.72A1,1,0,0,0,22,14.23Z"
});

var SvgIconAdd = function SvgIconAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-add.745fab77.svg";
export { ForwardRef as ReactComponent };